<template>
    <Card style="width: 100%;">
        <p slot="title">
            <Icon type="md-unlock" />
            权限设置
        </p>
        <Collapse >
            <template v-for="(menu, m) in list">
            <Panel :name="menu.label" :key="m">  
                <Icon :type="menu.icon" />{{menu.title}}
                <div class="ly-power-switch" @click.stop="">
                    <i-switch v-model="menu.isShow"></i-switch>
                </div>
                <!-- 二级菜单 start -->
                <Collapse slot="content" v-if="menu.isShow">
                    <template v-for="(submenu, p) in menu.children">
                    <Panel :name="submenu.label" :key="p">  
                        <Icon :type="submenu.icon" />{{submenu.title}}
                        <div class="ly-power-switch" @click.stop="">
                            <i-switch v-model="submenu.isShow"></i-switch>
                        </div>
                        <p slot="content" v-if="submenu.isShow">
                            <!-- 页面部分 start-->
                            <template  v-for="(page,s) in submenu.children" >
                                <div class="ly-power-set" :key="s">
                                    <h4>
                                        {{page.title}}
                                        <div class="ly-power-switch" @click.stop="">
                                            <i-switch v-model="page.isShow" size="small"></i-switch>
                                        </div>
                                    </h4>
                                    <Checkbox v-model="btn.isShow" v-for="(btn,i) in page.btns" :key="i">{{btn.title}}</Checkbox>
                                </div>
                            </template>
                            <!-- 页面部分  end -->
                        </p>
                        <div slot="content"  class="ly-power-no" v-else> 
                            权限未开启
                        </div>
                    </Panel>
                    </template>
                </Collapse>
                <!-- 二级菜单  end  -->
                <div slot="content"  class="ly-power-no" v-else> 
                    权限未开启
                </div>
            </Panel>
            </template>
        </Collapse>
    </Card>
</template>
<script>
    import { mapGetters, mapActions } from 'Vuex'
    import CompEventMixin from '@/utils/compEvent.mixin'
    import CompSendMixin from '@/utils/compSend.mixin'
    export default {
        name: 'LyPower',
        mixins: [CompEventMixin, CompSendMixin],
        props: {
            value: {
                type: [Array, Object, Boolean],
                default: _ => {}
            },
            attrs: {
                type: Object,
                default: _ => []
            }
        },
        computed: {
            ...mapGetters(['config']),
        },
        data () {
            return {
                switch1: true,
                list: []
            }
        },
        created () {
            this.initPowerList()
        },
        methods: {
            /**
             * 获取配置，提出需要权限设置的部分
             */
            initPowerList () {
                let config = this.config.config
                for (let i = 0, len = config.length; i < len; i++) {
                    let obj = config[i]
                    // 一级导航部分
                    let menu = {
                        label: obj.label,
                        title: obj.title,
                        icon: obj.icon,
                        isShow: true, // 标识是否显示
                        children:[]
                    }
                    // 二级导航部分
                    for (let j = 0, jlen = obj.children.length; j < jlen; j++) {
                        let obj_2 = obj.children[j]
                        let submenu = {
                            label: obj_2.label,
                            title: obj_2.title,
                            icon: obj_2.icon,
                            isShow: true, // 标识是否显示
                            children:[]
                        }
                        // 页面部分
                        for (let k = 0, klen = obj_2.page.length; k < klen; k++) {
                            let obj_3 = obj_2.page[k]
                            let page = {
                                label: obj_3.label,
                                title: obj_3.title,
                                isShow: true, // 标识是否显示
                                btns: []
                            }
                            // 遍历页面中的容器组件,获取当前页面需要设置权限的按钮
                            page.btns = this.getButtonList(obj_3.children)
                            submenu.children.push(page)
                        }

                        menu.children.push(submenu)
                    }
                    this.list.push(menu)
                }
            },
            /**
             * 获取页面中，ly-title按钮部分
             * @param comp 页面中的组件列表
             */
            getButtonList (comp) {
                let btnList = []
                for (let i = 0, len = comp.length; i < len; i++) {
                    if (comp[i]['name'] == 'ly-title') {
                        let children = comp[i]['children']
                        for (let j = 0, jlen = children.length; j < jlen; j++) {
                            let c = children[j]
                            btnList.push({
                                label: c.label,
                                title: c.title,
                                isShow: true
                            })
                        }
                    }
                }
                return btnList
            },
            /**
             * 得到page中的值后的回调函数
             */
            pageDataCallback () {
                // 稍微延迟下执行，避免数据获取到了，页面配置还没提取出来
                setTimeout(() => {
                    this.whileSetList(this.list, this.page)
                }, 500)
            },  
            /**
             * 通过递归对比，两份数据，进行设置当前数据
             */
            whileSetList (target, origin) {
                let origin_len = origin.length
                for (let i = 0, len = target.length; i < len; i++) {
                    // 为避免配置，增多减少的情况，通过label进行遍历对比
                    for (let j = 0, jlen = origin.length; j < jlen; j++) {
                        if (target[i]['label'] == origin[j]['label']) {
                            target[i]['isShow'] = origin[j]['isShow']
                            if (target[i]['children'] && origin[i]['children']) {
                                this.whileSetList(target[i]['children'], origin[i]['children'])
                            } else if (target[i]['btns'] && origin[i]['btns']) {
                                this.whileSetList(target[i]['btns'], origin[i]['btns'])
                            }
                            break;
                        }
                    }
                 }
            },
             /**
             * 有组件要提交数据的监听
             */
            handleGiveMeSubmitData () {
                // 发送需要提交的数据
                // power 是提交给后端的字段
                this.sendSubmitData({
                    power: this.list
                })
            }
        }
    }
</script>
<style>
    .ly-power-switch {
        float: right;
        padding-right: 5px;
    }
    .ly-power-set {
        padding-bottom: 12px;
        margin-bottom: 10px;
        border-bottom: 1px dashed #dfe6ec;
    }
    .ly-power-set h4 {
        margin-bottom: 10px;
    }
    .ly-power-set .ivu-checkbox-wrapper {
        margin-right: 10px;
    }
    .ly-power-no {
        padding:5px 0;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// ../projectCore/src/components/power/src/index.vue